export default "__VITE_ASSET__DrWrlfFS__"